<template>
	<section class="user-selector-list">
		<user-selector v-for="user in users"
					   :key="user.id"
					   :user="user"
					   v-on:radio-on-change="changeSelected">
		</user-selector>
	</section>
</template>

<script>
	import UserSelector from './UserSelector';

	function changeSelected(user) {
		this.$emit('on-change-selected', user);
	}

	export default {
		components: {
			UserSelector,
		},
		methods: {
			changeSelected,
		},
		name: 'user-selector-list',
		props: {
			users: {
				type: Array,
				required: true,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.user-selector-list {
		flex: none;
		text-align: left;
		width: 100%;
	}
</style>




// WEBPACK FOOTER //
// UserSelectorList.vue?f300ddf2